import { useState, useContext } from "react";
import { TimelineContext } from "../../helpers/Context";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";
import useTranslation from "../../hooks/useTranslation";
import { isMobile, isTablet } from "react-device-detect";

const CheckNoTecnicas = ({
  titulo,
  desripcion,
  object,
  options,
  selectedOption,
  onChange,
}) => {
  const T = useTranslation();
  const ctxTimeline = useContext(TimelineContext);
  const [idCheck, setIdCheck] = useState(null);

  const handlerCheck = (newIdCheck) => {
    setIdCheck(newIdCheck);
    const counterIDs = [];
    ctxTimeline.nonTechnical.map((item, index) => {
      if (item.object === object) {
        counterIDs.push(index);
        return true;
      }
    });

    if (counterIDs.length > 0) {
      ctxTimeline.nonTechnical[counterIDs[0]].selectedOption = newIdCheck;
    }

    if (onChange) {
      onChange();
    }
  };

  const checkboxDefaults = [
    {
      nameCheck: "deficit",
      idCheck: 1,
      color: "#FEEFF2",
      colorCheck: "#F9839A",
      dificultad: T("Déficit"),
      descripcion: "No Realiza",
    },
    {
      nameCheck: "adecuado",
      idCheck: 2,
      color: "#FDF7DB",
      colorCheck: "#F4D947",
      dificultad: T("Adecuado"),
      descripcion: "Realiza parcial",
    },
    {
      nameCheck: "excelente",
      idCheck: 3,
      color: "#EAF7F5",
      colorCheck: "#2AAC9C",
      dificultad: T("Excelente"),
      descripcion: "Realiza completo",
    },
  ];

  const data = options || checkboxDefaults;

  return (
    <>
      <hr className="my-4" />
      <div className="flex flex-col sm:flex-row sm:items-start gap-4 w-full">
        {/* Título y descripción */}
        <div className="flex flex-col w-full sm:w-2/5">
          <div
            className={`flex ${isMobile && !isTablet ? "" : "flex-col"} gap-2`}
          >
            <h4 className="text-lg font-bold text-left">{titulo}</h4>

            {isMobile && !isTablet ? (
              <>
                <FontAwesomeIcon
                  className="info-tooltip hover:text-white hover:bg-black bg-gray-200 p-1 w-3 h-3 rounded-full"
                  icon={faInfo}
                />
                <Tooltip anchorSelect=".info-tooltip" place="bottom">
                  <p className="text-xs text-white shadow rounded w-40">
                    {T(desripcion)}
                  </p>
                </Tooltip>
              </>
            ) : (
              <p className="text-xs text-left">{T(desripcion)}</p>
            )}
          </div>
        </div>

        {/* Opciones */}
        <div className="flex flex-wrap gap-2 w-full sm:w-3/5 justify-start">
          {data.map((item, index) => {
            const isSelected = options
              ? idCheck === index
              : idCheck === item.idCheck;
            const bgColor = isSelected ? item.colorCheck : item.color;
            const textColor =
              item.title === T("Adecuado") || !isSelected ? "black" : "white";

            return (
              <div
                key={item.idCheck}
                style={{ background: bgColor, color: textColor }}
                className="flex flex-1 h-24 rounded-[4px] flex-col justify-center items-center cursor-pointer gap-1"
                onClick={() => handlerCheck(options ? index : item.idCheck)}
              >
                <div
                  style={{
                    aspectRatio: 1,
                    height: 24,
                    backgroundColor: "white",
                    borderRadius: "50%",
                    borderWidth: 2,
                    borderColor: '#bbbbbb',
                  }}
                >
                  {isSelected && (
                    <div
                      style={{
                        background: "black",
                        height: "100%",
                        width: "100%",
                        borderRadius: "50%",
                        border: "2px solid white",
                      }}
                    />
                  )}
                </div>
                <div className="flex flex-col items-center">
                  <h4 className="text-[16px]">
                    {options ? item.title : item.dificultad}
                  </h4>
                  {options && (
                    <>
                      <p style={{ textAlign: "center" }} className="text-xs">
                        {T(item.desc)}
                      </p>
                    </>
                  )}
                </div>
                {!options && (
                  <p className="text-[14px] text-center">{item.descripcion}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CheckNoTecnicas;
